import classNames from 'classnames'
import PropTypes from 'prop-types'

import CheckIcon from '@mui/icons-material/Check'

import Button from '../../../../../shared_components/mui_base_components/button/Button'
import ButtonGroup from '../../../../../shared_components/mui_base_components/button/ButtonGroup'

const TOTAL_STEPS = 5
const FULL_SCREEN_STEPS = [1, 2, 4]

const TfaWizardStepFrame = props => {
  const progressItems = Array.from({length: TOTAL_STEPS}, (unusedValue, index) => {
    const step = index + 1

    if (step < props.currentStep)
      return 'complete'

    if (step === props.currentStep)
      return 'active'

    return 'upcoming'
  })

  return (
    <div className='tfa-wizard-step-frame'>
      <ol className='tfa-wizard-progress' aria-label='Two-factor authentication setup progress'>
        {
          progressItems.map((status, index) => (
            <li className={`tfa-wizard-progress-item tfa-wizard-progress-item-${status}`} key={index}>
              {index > 0 && <span className='tfa-wizard-progress-line' />}
              <span className='tfa-wizard-progress-marker'>
                {
                  status === 'complete' ?
                    <CheckIcon fontSize='inherit' /> :
                    index + 1
                }
              </span>
            </li>
          ))
        }
      </ol>
      <div className={classNames('tfa-wizard-card', (!FULL_SCREEN_STEPS.includes(props.currentStep) || (props.currentStep === 2 && props.enrollmentMode !== 'app')) ? 'tfa-wizard-card-centered' : '')}>
        <header
          className={classNames(
            'tfa-wizard-card-header',
            {'tfa-wizard-card-header-final': props.currentStep === 5}
          )}>
          <h2 className='tfa-wizard-title'>{props.title}</h2>
          {props.subtitle && <p className='tfa-wizard-subtitle'>{props.subtitle}</p>}
        </header>
        <div className={`tfa-wizard-content ${props.contentClassName}`.trim()}>
          {props.children}
        </div>
        <ButtonGroup
          className={classNames(
            'tfa-wizard-btn-group',
            {
              'tfa-wizard-btn-group-final': props.currentStep === 5,
              'tfa-wizard-btn-group-with-app-enrollment-mode': props.enrollmentMode === 'app'
            }
          )}>
          {
            props.secondaryActionLabel && props.onSecondaryAction &&
            <Button
              className='tfa-wizard-secondary-btn btn'
              color='cancel'
              disabled={props.secondaryDisabled}
              onClick={props.onSecondaryAction}
              type='button'>
              {props.secondaryActionLabel}
            </Button>
          }
          {
            props.primaryActionLabel &&
            <Button
              className='tfa-wizard-primary-btn'
              disabled={props.primaryDisabled}
              loading={props.primaryLoading}
              onClick={props.onPrimaryAction}>
              {props.primaryActionLabel}
            </Button>
          }
        </ButtonGroup>
      </div>
    </div>
  )
}

TfaWizardStepFrame.propTypes = {
  children: PropTypes.node,
  contentClassName: PropTypes.string,
  currentStep: PropTypes.number,
  enrollmentMode: PropTypes.string,
  onPrimaryAction: PropTypes.func,
  onSecondaryAction: PropTypes.func,
  primaryActionLabel: PropTypes.string,
  primaryDisabled: PropTypes.bool,
  primaryLoading: PropTypes.bool,
  secondaryActionLabel: PropTypes.string,
  secondaryDisabled: PropTypes.bool,
  subtitle: PropTypes.string,
  title: PropTypes.string
}

TfaWizardStepFrame.defaultProps = {
  children: null,
  contentClassName: '',
  currentStep: 1,
  onPrimaryAction: null,
  onSecondaryAction: null,
  primaryActionLabel: '',
  primaryDisabled: false,
  primaryLoading: false,
  secondaryActionLabel: '',
  secondaryDisabled: false,
  subtitle: '',
  title: ''
}

export default TfaWizardStepFrame
